import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
// import { Button, Card, CardBody, Col, Container, Input, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import { Button, Card, CardBody, Col, Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import useAxios from 'hooks/useAxios';
import Loader from 'components/Loader';
import moment from 'moment';
import cancel from "assets/icon/cancel.svg";
import save from "assets/icon/save.svg";
import Confirm from 'components/Confirm';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import { cloneDeep } from 'lodash';
import Drawer from 'components/Drawer';
import NDCAccumulationDetails from 'pages/Accumulations/AccumulationsN';
import { toast } from 'react-toastify';
import InfoIcon from 'assets/icon/AddWholeSaler.svg';

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: '',
  order: '',
  filters: [],
};

let checkedIds = [];
let allcheckids = [];
let rowForEdit = {};
let tempData = [];
let changedCompleteRows = [];
let allcheckFlag = false;
let nonSelectableStatuses = [
  "Item Billed",
  "Item Billed - Short Shipped",
  "Item Billed - Over Shipped",
  "Item Cancelled",
  "Item Complete",
  "Item Not Billed - BackOrder",
  "Item Returned",
  "Post Split NDC"
];

const ViewPurchaseOrder = (props) => {
  const {
    rowData,
    orgId, search,
    SelectedAccumulator,
    toggleViewPODetailsDrawer
  } = props;
  const { poid, poType } = rowData;


  const API = useAxios();
  const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [hasSelectableRows, setHasSelectableRows] = useState(false);
  const [allSelectDisabled, setAllSelectDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalitem, setTotalItem] = useState(0);
  const [selectedRow, setselectedRow] = useState({});
  const [allCheckDefault, setAllCheckDefault] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [allCheck, setAllCheck] = useState("singleCheck");
  const [editbtn, setEditbtn] = useState(true);
  const [hideeditbtn, setHideEditbtn] = useState(false);
  const [modal, setModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState({})


  const toggle = () => setModal(!modal);

  useEffect(() => {
    tempData = [];
    checkedIds = [];
    checkedIds = [];
    allcheckids = [];
    allcheckFlag = false;
    fetchPOOrderDetails();
    allcheckFlag = false;
  }, []);
  const fetchPOOrderDetails = async (filter) => {
    let payload = {};
    if (filter !== undefined && filter !== null) {
      payload.CurrentPage = filter.currentPage;
      payload.pageSize = filter.pageSize === undefined ? initialFilters.pageSize : filter.pageSize;
      initialFilters.currentPage = filter.currentPage;
      initialFilters.pageSize = filter.pageSize === undefined ? initialFilters.pageSize : filter.pageSize;
    }
    else {
      payload.CurrentPage = 1;
      payload.pageSize = 10;
      initialFilters.currentPage = 1;
      initialFilters.pageSize = 10;
    }
    payload.orderBy = "poid",
      payload.order = "desc",
      payload.filters = [],
      payload.AccumulatorIDs = [SelectedAccumulator[0]],
      payload.AccountTypeID = 0,
      payload.POStatusID = 0,
      payload.Invoice = ""

    try {

      setLoading(true);
      const { data } = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/GetViewPurchaseOrderDetails/${poid}`, payload,
        { hasDefaultURL: true, }
      )

      if (data) {
        const items = data.items || [];
        const selectableItems = items.filter(row => !nonSelectableStatuses.includes(row.itemStatus));
        setHasSelectableRows(selectableItems.length > 0);
        setAllSelectDisabled(selectableItems.length === 0 ? true : false);
        setOriginalData(items.map(row => ({ ...row })));
        setData(data.items);
        setTotalItem(data.totalRecords);
        // const selectableItems = items.some(row => !["Item Billed", "Item Billed - Short Shipped", "Item Billed - Over Shipped", "Item Cancelled", "Item Complete", "Item Not Billed - BackOrder", "Item Returned", "Post Split NDC"].includes(row.itemStatus));
        setLoading(false);

        tempData = items.map(row => ({
          ...row,
          isEdit: false,
          checkFlag: false,
        }));
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const togglePODetailsDrawer = (rowData) => {
    setisPODetailsOpen(!isPODetailsOpen);
  };

  const handlePODetails = (rowData) => {
    setisPODetailsOpen(!isPODetailsOpen);
    setselectedRow(rowData);
  };
  const cellRenderLink = (rowData) => {
    // if (hasPermission('VWPO')) {
    return (
      <span
        className='text-decoration-underline d-inline-block cursor-pointer'
        onClick={() => handlePODetails(rowData)}
      >
        {rowData.ndc}
      </span>
    );
    // }
  };
  const handleExport = async () => {
    const filterObj = cloneDeep(search);
    //filterObj.ActiveButton = ActiveButton
    // if (columnFilters && columnFilters.length > 0) {
    //   filterObj.filters = [...filterObj.filters, ...columnFilters];
    // }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    additionalCriteria.POId = poid;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "viewsearchOrder";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
    //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
    //  onExport(action, initialFilters);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      fetchPOOrderDetails(colFilterOn, true);
    } else {
      fetchPOOrderDetails(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return fetchPOOrderDetails(colFilterOn, true);
    }
    fetchPOOrderDetails(filter);
  };

  const dateFormateTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    const options = {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };

    return date.toLocaleString('en-US', options).replace(',', '');
  };

  //SBS-4021 Ability to Update, Cancel items or orders to invoiced update the quantity and price mark as invoiced.
  const formatter = (row, col, formatterType, alwaysEditableCheckbox, validationError) => {
    if (formatterType == "date") {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
          showWarning={validationError}
        />
      );
    } else {
      return (
        <CellEditRender
          row={row}
          col={col}
          formatterType={formatterType}
          onChange={updateRowValue}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
          validationError={validationError}
          requiredFields={formatterType}
        />
      );
    }
  };


  const updateRowValue = (value, col, rowData) => {
    tempData = tempData.map((row) => {
      if (row.poItemID === rowData?.poItemID) {
        return {
          ...row,
          [col]: value,
        };
      }

      return row;
    });

    // Remove validation error for this particular field
    setValidationErrors((prev) => {
      const rowErrors = prev[rowData?.poItemID];

      if (!rowErrors || !rowErrors[col]) {
        return prev;
      }

      const updatedRowErrors = { ...rowErrors };
      delete updatedRowErrors[col];

      const updatedErrors = { ...prev };

      if (Object.keys(updatedRowErrors).length === 0) {
        delete updatedErrors[rowData.poItemID];
      } else {
        updatedErrors[rowData.poItemID] = updatedRowErrors;
      }

      return updatedErrors;
    });
  };
  const handleAllCheckbox = (e) => {
    const isChecked = e.target.checked;

    setAllCheckDefault(isChecked);
    setAllCheck(isChecked ? "checkall" : "singleCheck");

    if (isChecked) {
      //CheckAll
      setEditbtn(true);
      setHideEditbtn(false);
      checkedIds = [];
      allcheckids = [];
      // const selectableRows = originalData.filter(
      //   row => !["Item Billed", "Item Billed - Short Shipped", "Item Billed - Over Shipped", "Item Complete", "Item Cancelled"].includes(row.itemStatus)
      // );
      const selectableRows = data.filter(row => !nonSelectableStatuses.includes(row.itemStatus) || (row.itemStatus === "Item Cancelled" && row.checkFlag === true));
      checkedIds = selectableRows.map(row => row.poItemID);
      allcheckids = [...checkedIds];

      setSelectedIds([...checkedIds]);

      tempData = tempData.map(row => {
        if (checkedIds.includes(row.poItemID)) {
          const originalRow = originalData.find(item => item.poItemID === row.poItemID);
          if (!originalRow) { return row; }
          return {
            ...originalRow,
            isEdit: false,
            checkFlag: true,
            itemStatus: "Item Cancelled",
          };
        }
        return row;
      });
    } else {
      //unCheck
      const selectedNdcIds = [...checkedIds];
      setSelectedIds([]);

      tempData = tempData.map(row => {
        if (selectedNdcIds.includes(row.poItemID)) {
          const originalRow = originalData.find(item => item.poItemID === row.poItemID);

          if (!originalRow) { return row; }

          return {
            ...originalRow,
            isEdit: !nonSelectableStatuses.includes(originalRow.itemStatus) ? !editbtn : false,
            checkFlag: false,
          };
        }
        return row;
      });
      checkedIds = [];
      allcheckids = [];
    }
    setData(tempData.map(row => ({ ...row })));
  };

  const handlesingleCheckbox = (rowData) => {
    const { poItemID } = rowData;
    const index = checkedIds.indexOf(poItemID);
    const originalRow = originalData.find((row) => row.poItemID === poItemID);
    if (!originalRow) {
      return;
    }

    if (index >= 0) {
      //checkbox uncheck
      checkedIds.splice(index, 1);

      tempData = tempData.map((row) => {
        if (row.poItemID === poItemID) {
          return {
            ...originalRow,
            isEdit: !nonSelectableStatuses.includes(originalRow.itemStatus) ? !editbtn : false,
            checkFlag: false,
          };
        }
        return row;
      });

    } else {
      //checkBox Check
      checkedIds.push(poItemID);
      tempData = tempData.map((row) => {
        if (row.poItemID === poItemID) {
          return {
            ...originalRow,
            isEdit: false,
            checkFlag: true,
            itemStatus: "Item Cancelled",
          };
        }
        return row;
      });
    }
    setSelectedIds([...checkedIds]);
    //checking all selected checkbox
    //  const selectedRows = originalData.filter(row => !["Item Cancelled", "Item Complete"].includes(row.itemStatus));
    const selectedRows = data.filter(row => !nonSelectableStatuses.includes(row.itemStatus) || (row.itemStatus === "Item Cancelled" && row.checkFlag === true));

    if (checkedIds.length === selectedRows.length) {
      setAllCheckDefault(true);
      setAllCheck("checkall");
    } else {
      setAllCheckDefault(false);
      setAllCheck("singleCheck");
    }
    setData(prevData => prevData.map(row => row.poItemID === poItemID
      ? tempData.find(tempRow => tempRow.poItemID === poItemID) : row));
  }

  const renderCheckbox = (rowData) => {
    const filter = selectedIds.filter((item) => item == rowData.poItemID);
    return (
      <Input style={{ position: "relative", border: "1px solid #919191", left: "24px", width: "14px", height: "14px" }}
        type="checkbox"
        className="me-2 mt-0"
        hidden={poType === "Manual Non-Split" || data.length == 0 ||
          (!rowData.checkFlag && nonSelectableStatuses.includes(rowData.itemStatus))}
        checked={filter.length > 0}
        onChange={() => handlesingleCheckbox(rowData)}
      />
    )
  }

  const isNonSplit = poType === "Manual Non-Split" || poType === "Non-Split";

  let mainCol = [
    {
      dataField: 'edit',
      text: (
        <div>
          <label style={{ color: '#212121' }}>Cancel All</label>
          <Input style={{ position: "relative", left: "4px", top: "-4px", border: "1px solid #919191", width: "14px", height: "14px" }}
            type='checkbox'
            title={allcheckids.length == 0 ? "select all" : "unselect all"}
            onChange={(e, row) => {
              handleAllCheckbox(e, row)
            }}
            hidden={!hasSelectableRows || poType === "Manual Non-Split" || poType === "Non-Split" || allSelectDisabled}
            checked={allCheckDefault}
          />
        </div>
      ),
      cellRenderer: (rowData) => renderCheckbox(rowData),
      width: 120,
      show: isNonSplit ? false : true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: 'ndc',
      text: 'NDC',
      cellRenderer: (row) => cellRenderLink(row),
      width: 80,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },

    {
      dataField: 'drugName',
      text: 'Drug Name',
      sort: false,
      width: 240,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.drugName),
    },
    {
      dataField: 'itemStatus',
      text: 'Item Status',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.itemStatus),
    },
    {
      dataField: 'qtyOrder',
      text: 'Qty Ordered',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.qtyOrder),
    },
    {
      dataField: 'qtyAck',
      text: 'Qty Ack',
      sort: false,
      width: 80,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.qtyAck),
    },
    {
      dataField: 'qtyInvoiced',
      text: 'Qty Invoiced',
      sort: false,
      width: 140,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      edit: true,
      cellRenderer: (row, col) => formatter(row, col, "Numericnumber", false, validationErrors[row.poItemID]?.[col.dataField]),
    },
    {
      dataField: 'qtyReceived',
      text: 'Qty Received',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.qtyReceived),
    },
    {
      dataField: 'dateAck',
      text: 'Date Ack',
      sort: false,
      width: 140,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (row) => dateFormateTime(row.dateAck),
    },
    {
      dataField: 'invoicedDate',
      text: 'Invoiced Date',
      sort: false,
      width: 170,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      edit: true,
      cellRenderer: (row, col) => formatter(row, col, "date", false, validationErrors[row.poItemID]?.[col.dataField]),//dateFormate(row.invoicedDate),
    },
    {
      dataField: 'pkgPrice',
      text: 'Pkg Price',
      sort: false,
      width: 120,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => currencyFormat(row.pkgPrice),
    },
    {
      dataField: 'ackPkgPrice',
      text: 'Ack Pkg Price',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => currencyFormat(row.ackPkgPrice),
    },
    {
      dataField: 'invoicedPkgPrice',
      text: 'Invoiced Pkg Price',
      sort: false,
      width: 140,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      edit: true,
      cellRenderer: (row, col) => row.isEdit == true ? formatter(row, col, "Numericnumber", false, validationErrors[row.poItemID]?.[col.dataField]) : currencyFormat(parseFloat(row.invoicedPkgPrice)),
    },
    {
      dataField: 'totalOrdPrice',
      text: 'Total Ord Price',
      sort: false,
      width: 150,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => currencyFormat(row.totalOrdPrice),
    },
    {
      dataField: 'totalAckPkgPrice',
      text: 'Total Ack Pkg Price',
      sort: false,
      width: 120,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => currencyFormat(row.totalAckPkgPrice),
    },
    {
      dataField: 'totalInvoicedPrice',
      text: 'Total Invoiced Price',
      sort: false,
      width: 120,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => currencyFormat(row.totalInvoicedPrice),
    },
    {
      dataField: 'invoiceNumber',
      text: 'Invoice #',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      edit: true,
      cellRenderer: (row, col) => formatter(row, col, "text", false, validationErrors[row.poItemID]?.[col.dataField]),//cellRendererCheck(row.invoiceNumber),
    },


  ];

  const handleEditbtn = (hasSave, isEdit = true) => {
    if (isEdit && hasSelectableRows && poType !== "Manual Non-Split") {

      setEditbtn(false);
      setHideEditbtn(true);

      tempData = tempData.map(row => ({
        ...row,
        isEdit: !row.checkFlag && !nonSelectableStatuses.includes(row.itemStatus),
      }));
    } else if (!hasSave && !isEdit) {
      setEditbtn(true);
      setHideEditbtn(false);
      setValidationErrors({});
      tempData = data;
      tempData = tempData.map((row) => {
        row.isEdit = isEdit;
        return row;
      });

    } else if (hasSave && !isEdit) {
      saveEditedRows();
    }
  }

  const validateEditedRows = () => {
    const errors = {};

    tempData.forEach((row) => {
      const oldRow = data.find((item) => item.poItemID === row.poItemID);

      const isChanged =
        oldRow.qtyInvoiced !== row.qtyInvoiced ||
        oldRow.invoicedDate !== row.invoicedDate ||
        oldRow.invoicedPkgPrice !== row.invoicedPkgPrice ||
        oldRow.invoiceNumber !== row.invoiceNumber;

      // Only validate edited rows
      if (!isChanged) {
        return;
      }

      const currentErrors = {};

      if (row.qtyInvoiced === null || row.qtyInvoiced === undefined || String(row.qtyInvoiced).trim() === "" || row.qtyInvoiced === 0) {
        currentErrors.qtyInvoiced = "Qty Invoiced is required";
      }

      if (row.invoicedDate === null || row.invoicedDate === undefined || String(row.invoicedDate).trim() === "") {
        currentErrors.invoicedDate = "Invoiced Date is required";
      }

      if (row.invoicedPkgPrice === null || row.invoicedPkgPrice === undefined || String(row.invoicedPkgPrice).trim() === "" || row.invoicedPkgPrice === 0) {
        currentErrors.invoicedPkgPrice =
          "Invoiced Pkg Price is required";
      }

      if (row.invoiceNumber === null || row.invoiceNumber === undefined || String(row.invoiceNumber).trim() === "") {
        currentErrors.invoiceNumber = "Invoice # is required";
      }

      // Store errors for this row
      if (Object.keys(currentErrors).length > 0) {
        errors[row.poItemID] = currentErrors;
      }
    });
    return errors;
  };


  const saveEditedRows = () => {
    const errors = validateEditedRows();
    setValidationErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }
    const updatedData = tempData.map((row) => {
      const oldRow = data.find((item) => item.poItemID === row.poItemID);

      const isChanged = oldRow.qtyInvoiced !== row.qtyInvoiced || oldRow.invoicedDate !== row.invoicedDate || oldRow.invoicedPkgPrice !== row.invoicedPkgPrice || oldRow.invoiceNumber !== row.invoiceNumber;

      if (!isChanged) {
        return {
          ...row,
          itemStatus: row.checkFlag === true ? "Item Cancelled" : row.itemStatus,
          isEdit: false,
        };
      }
      return {
        ...row,
        itemStatus: getItemStatus(row),
        isEdit: false,
      };
    });
    tempData = updatedData;
    setData(updatedData.map((row) => ({ ...row })));
    setEditbtn(true);
    setHideEditbtn(false);
  };

  const getItemStatus = (row) => {
    const qtyOrder = Number(row.qtyOrder) || 0;
    const qtyInvoiced = Number(row.qtyInvoiced) || 0;
    if (row.checkFlag === true) {
      return "Item Cancelled";
    }
    if (row.qtyInvoiced === "0") {
      return "Item Not Billed - BackOrder";
    }
    if (qtyOrder === qtyInvoiced) {
      return "Item Billed";
    }
    if (qtyOrder > qtyInvoiced) {
      return "Item Billed - Short Shipped";
    }
    if (qtyOrder < qtyInvoiced) {
      return "Item Billed - Over Shipped";
    }
    return row.itemStatus;
  };

  // SBS-4538 Search order: While cancelling the item the item and order status statuses are changing to item billed and order billed statuses
  const getChangedCompleteRows = () => {
    return data.filter(row => {
      const originalRow = originalData.find(
        original => original.poItemID === row.poItemID
      );

      return (
        originalRow &&
        originalRow.itemStatus !== row.itemStatus &&
        row.itemStatus !== "Item Cancelled"
      );
    });
  };


  const checkChanges = () => {
    changedCompleteRows = getChangedCompleteRows();
    if (changedCompleteRows.length === 0 && selectedIds.length === 0) {
      return;
    }
    toggle();
  };

  const handleSubmit = async () => {
    toggle();
    const AddPOOrderModelfilter = changedCompleteRows.map(row => ({
      Totalprice: row.totalOrdPrice,
      Qtyreceived: row.qtyReceived,
      Qtyordered: row.qtyOrder,
      Qtybilled: row.qtyInvoiced,
      Packagesprice: row.pkgPrice,
      QtyInvoicedPrice: row.invoicedPkgPrice,
      Packagecomplte: row.qtyAck,
      Ndc: row.ndc,
      ItemInvoiceNumber: row.invoiceNumber,
      ItemInvoicedDate: row.invoicedDate ? moment(row.invoicedDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss") : null,
      POItemID: row.poItemID,
      Comment: row.comment ?? null
    }));

    const payload = {
      AddPOOrderModelfile: {
        WholesalerId: rowData.wholesalerID,
        AccountTypeID: rowData.accountType == "340B" ? 1001 : rowData.accountType == "GPO" ? 1002 : 1003,
        AccountNumber: rowData.accountCode,
        InvoiceDate: rowData.itemInvoicedDate,
        PONumber: rowData.poid.toString(),
        AddPOOrderModelfilter: AddPOOrderModelfilter
      },
      Poitemids: {
        POitemNumbers: selectedIds
      }
    };

    try {
      setLoading(true);
      const { data } = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/EditCancelPurchaseOrder/${SelectedAccumulator}/${allCheck}`, payload,
        { hasDefaultURL: true, }
      )
      if (data?.error == false) {
        toast.success(data?.message);
        toggleViewPODetailsDrawer(true);

      } else if (data?.error == true) {
        toast.error(data?.message);
      }

    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }


  return (
    <>
      <Card>
        <CardBody>
          <div className="">
            <Row>
              <h4 className="f-15 text-primary font-weight-700">View Order </h4>

              <Col md="4">
                <p className="m-0 f-14 mt-2">Account Type : </p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {rowData.accountType}
                </p>
              </Col>

              <Col md="4">
                <p className="m-0 f-14 mt-2">PO Number : </p>
                <p className="m-0 f-14 font-weight-500 mt-1">{rowData.poid}</p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-2">PO Date : </p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {moment(rowData.poDate).format("MM/DD/YYYY")}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-2">PO Status : </p>
                <p className="m-0 f-14 font-weight-500 mt-1">{rowData.poStatusID}</p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-2">Wholesaler Name : </p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {rowData.wholesalerName}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-2">Ordered Price : </p>
                <span className="m-0 f-14 font-weight-500 mt-1"></span>

                <p className="m-0 f-14 font-weight-500 mt-1">
                  {(currencyFormat(rowData.totalOrderedPrice))}
                </p>
              </Col>
              <Col md="4">
                <p className="m-0 f-14 mt-2">Invoiced Price : </p>
                <span className="m-0 f-14 font-weight-500 mt-1"></span>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {(currencyFormat(rowData.totalInvoicedPrice))}
                </p>
              </Col>
            </Row>
            <hr></hr>
            <div
              className="table-card scroll-table position-relative border-0 rounded pt-0"
              fixed-height={data.length > 0 ? "fixed-height" : "default"}
            >
              {loading && <Loader opacity={0.02} color="black" />}

              <ReactStrapTable
                id="vieworder-table"
                height={550}
                fixedColumn
                width={1200}
                // hasPagination
                isNonSplit={isNonSplit}
                data={tempData}
                add={"Edit"}
                addbutton={editbtn}
                addAccmulations={false}
                buttononclick={handleEditbtn}
                cancelonClick={handleEditbtn}
                saveonClick={handleEditbtn}
                saveEdit={hideeditbtn}
                hasExportPermission={editbtn}
                columns={mainCol}
                hidefilter
                display={true}
                onExport={handleExport}
                totalRecords={totalitem}
                pageSize={initialFilters.pageSize}
                currentPage={initialFilters.currentPage}
                onPageChange={onHandlePageChange}
                onPageSizeChange={onPageSizeChange}
              />
              <Row className="d-flex mt-3" style={{ justifyContent: "flex-end" }}>
                {!isNonSplit && (
                  <Col md={12}>
                    <div className="mb-3"
                      style={{
                        background: "#DBC8D8",
                        color: "#702C62",
                        padding: "8px 12px",
                        borderRadius: "4px",
                        width: "fit-content",
                        display: "flex",
                        alignItems: "flex-start",
                      }}
                    >
                      <img
                       src={InfoIcon}
                        alt="Info"
                        style={{
                          width: "16px",
                          height: "16px",
                          flexShrink: 0,
                          marginTop: "2px",
                        }}
                      />
                      <p className="m-0 f-14 ms-2 ">
                        Selected items will be locked for editing and marked as eligible for cancellation
                      </p>
                    </div>
                  </Col>
                )}
                <Col md="auto">
                  <Button className='search ms-3' color='primary' onClick={() => checkChanges()} hidden={isNonSplit}>
                    <span><img src={save} alt='' /></span> Submit Changes
                  </Button>
                </Col>
              </Row>

              <Drawer
                direction="end"
                title="NDC Historical Purchase Details"
                isOpen={isPODetailsOpen}
                toggle={togglePODetailsDrawer}
                size="lg"
              >
                <NDCAccumulationDetails tenantID={orgId} rowData={selectedRow} />

              </Drawer>
            </div>
          </div>
        </CardBody>
      </Card>
      <Confirm
        isOpen={modal}
        message="Are you sure, you want to submit the edit / cancellation changes for the items in this order?"
        onToggle={toggle}
        onCancel={toggle}
        onContinue={handleSubmit}
      />
    </>
  );
}

export default ViewPurchaseOrder
